import { useState, useCallback } from "react";
import { ResultsApi, Configuration } from "manager-common";
import { useAuth } from "react-oidc-context";
import { useApiConfig, SERVER_ERROR_MESSAGE } from "common-fe";

const MANAGER_API_BASE_URL = import.meta.env.VITE_MANAGER_API_BASE_URL;

/**
 * Hook for fetching merged rides preview
 * Returns preview of merged rides with combined scores from technical and quality classes
 */
export function useMergedPreview() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const auth = useAuth();
  const buildConfig = useApiConfig();

  const fetchPreview = useCallback(async (technicalId, qualityId) => {
    if (!technicalId || !qualityId || !auth.user?.access_token) {
      setError("Missing required IDs or authentication");
      return [];
    }

    setLoading(true);
    setError(null);

    try {
      const api = new ResultsApi(
        new Configuration(buildConfig(MANAGER_API_BASE_URL))
      );

      const response = await api.getMergedRidesPreview({
        technical: technicalId,
        quality: qualityId,
      });

      return response.data?.results || [];
    } catch (err) {
      console.error("Error fetching merged preview:", err);
      const errorMessage = SERVER_ERROR_MESSAGE;
      setError(errorMessage);
      return [];
    } finally {
      setLoading(false);
    }
  }, [auth.user?.access_token, buildConfig]);

  return { fetchPreview, loading, error };
}
